import { downloads } from '@/mocks/home';

export default function DownloadSection() {
  return (
    <section id="download" className="py-14 md:py-20 bg-accent-50">
      <div className="w-full max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
          即刻下载mogu视频
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-md mx-auto">
          随时随地发现时尚好物，边看边买的沉浸式购物体验，尽在mogu视频App
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          {downloads.map((dl) => (
            <a
              key={dl.platform}
              href={dl.url}
              className="flex items-center gap-3 px-8 py-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-8 h-8 flex items-center justify-center text-primary-600">
                <i className={`${dl.icon} text-2xl`}></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-400 whitespace-nowrap">在</div>
                <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{dl.label}</div>
              </div>
            </a>
          ))}
        </div>

        <p className="text-xs text-foreground-400 mt-6">
          支持 iOS 14+ 和 Android 8.0+ 系统
        </p>
      </div>
    </section>
  );
}